// extracted by mini-css-extract-plugin
export default {"wrapper":"guide-box_wrapper__p0XjM"};